function capitalizeBillerName(billerName) {
    if(!billerName){
        return;
    }
    const billersToUpperCase = ['mtn', 'glo', 'dstv'];
    billerName = billerName?.toLowerCase();

    if (billersToUpperCase?.includes(billerName)) {
        return billerName?.toUpperCase();
    } else if (billerName === '9mobile') {
        return billerName?.slice(0,1) + billerName?.charAt(1)?.toUpperCase() + billerName?.slice(2);
    } 
    else {
        return billerName?.charAt(0)?.toUpperCase() + billerName?.slice(1);
    }
}

export { capitalizeBillerName }
